import { DocumentSchema, SchemaNode } from '../../../documents/types';

export interface PreviewRenderDocument {
    schema: DocumentSchema;
    data: Record<string, any>;
    sourceKey?: string;
    sourceLabel?: string;
    dataSources?: Record<string, any[]>;
}

const visitNodeIds = (node: SchemaNode, counts: Map<string, number>) => {
    if (node.kind === 'section') {
        const fields = Array.isArray(node.fields) ? node.fields : [];
        fields.forEach((field) => visitNodeIds(field, counts));
        return;
    }

    const currentCount = counts.get(node.id) || 0;
    counts.set(node.id, currentCount + 1);
};

export const normalizePreviewDocuments = (
    documents: PreviewRenderDocument[] | null | undefined
): PreviewRenderDocument[] => {
    if (!Array.isArray(documents)) return [];

    return documents
        .filter((document) => !!document?.schema)
        .map((document) => ({
            schema: document.schema,
            data:
                document.data &&
                typeof document.data === 'object' &&
                !Array.isArray(document.data)
                    ? document.data
                    : {},
            sourceKey: document.sourceKey,
            sourceLabel:
                document.sourceLabel ||
                document.schema.title ||
                document.schema.id,
            dataSources: document.dataSources,
        }));
};

export const collectNodeIdCounts = (
    documents: PreviewRenderDocument[]
): Map<string, number> => {
    const counts = new Map<string, number>();

    documents.forEach((document) => {
        const sections = Array.isArray(document.schema.sections)
            ? document.schema.sections
            : [];
        sections.forEach((section) => visitNodeIds(section, counts));
    });

    return counts;
};

export const isDuplicateNodeId = (
    nodeId: string,
    counts: Map<string, number>
): boolean => {
    return (counts.get(nodeId) || 0) > 1;
};

export const withSourceLabelIfDuplicate = (
    title: string,
    nodeId: string,
    sourceLabel: string,
    counts: Map<string, number>
): string => {
    if (!isDuplicateNodeId(nodeId, counts)) return title;
    return `${title} (${sourceLabel})`;
};
